import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <h2 className="section-title">About Me</h2>
      <div className="about-content">
        <div className="about-text">
          <p>
           A Machine Learning and AI Engineer with a strong passion for building intelligent systems that bridge cutting-edge AI research with real-world applications. My expertise spans agentic systems, retrieval-augmented generation (RAG), predictive modeling, and symbolic AI, with hands-on experience in Python, TensorFlow, LangChain and LangGraph, MCP, REST API development, and Docker. I have a proven track record of developing advanced AI pipelines, fine-tuning large language models using LoRA and QLoRA, and integrating AI solutions into diffrent domains.
          </p>
          <p>
          With specializations in Machine Learning, and Mathematics, I combine technical depth with problem-solving and strategic thinking to design scalable AI systems that deliver measurable value and positive societal impact.
          </p>
          </div>
        <div className="skills-overview">
          <div className="skill-category">
            <h3>Technical Expertise</h3>
            <ul>
              <li>Python Development</li>
              <li>Machine Learning</li>              
              <li>TensorFlow</li>
              <li>Agentic Systems</li>
              <li>Neural Networks</li>
              <li>API Development</li>
            </ul>
          </div>
          <div className="skill-category">
            <h3>Soft Skills</h3>
            <ul>
              <li>Problem Solving</li>
              <li>Critical Thinking</li>
              <li>Time Management</li>
              <li>Team Collaboration</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
